import {
	UntypedFormArray,
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
} from '@angular/forms';
import { BaseResponse } from './base-response.model';
import { Validation } from './validation.model';

export interface PetResponse extends BaseResponse {
	message: string;
	pets: PetJSON[];
}

export interface PetJSON {
	id: number;
	type: string;
	size: string;
}

export class Pet {
	constructor(
		public id: number,
		public type: string,
		public size: string
	) {}

	static fromJSON(json: PetJSON): Pet {
		return Object.assign(Object.create(Pet.prototype), json, {});
	}

	static createFormArray(
		pets: Pet[],
		validation: Validation
	): UntypedFormArray {
		return pets
			? new UntypedFormArray(
					pets.map((pet) => this.createFormGroup(pet, validation))
				)
			: new UntypedFormArray([]);
	}

	static createFormGroup(pet: Pet, validation: Validation): UntypedFormGroup {
		return new UntypedFormGroup({
			id: new UntypedFormControl(pet ? pet.id : null),
			type: new UntypedFormControl(pet ? pet.type : '', [
				Validators.required,
				Validators.maxLength(validation.name.maxLength),
				Validators.pattern(validation.name.pattern),
			]),
			size: new UntypedFormControl(pet ? pet.size : '', [
				Validators.required,
				Validators.maxLength(validation.alnum.maxLength),
				Validators.pattern(validation.alnum.pattern),
			]),
		});
	}

	static arrayFromFormGroup(fg: UntypedFormGroup): Pet[] {
		const fa: UntypedFormArray = fg.get('pets') as UntypedFormArray;
		return fa.length > 0
			? fa.controls.map((petFG: UntypedFormGroup) =>
					this.fromFormGroup(petFG)
				)
			: [];
	}

	static fromFormGroup(fg: UntypedFormGroup): Pet {
		return Object.assign(Object.create(Pet.prototype), {
			id: fg.value['id'],
			type: fg.value['type'],
			size: fg.value['size'],
		});
	}
}
